import React, { useEffect, useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from "../asset/logowhite.png";
import loginbg from "../asset/login/login.png";
import { useNavigate } from "react-router-dom";
import SummaryApi from "../common";
import { FaArrowLeft } from "react-icons/fa";
const InstructorOtp = () => {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const inputsRef = useRef([]);
  const navigate = useNavigate();
const [loading, setLoading] = useState(false);

  useEffect(() => {
    const storedOtp = localStorage.getItem("instructor_otp");
    if (storedOtp) {
      toast.info("OTP has been sent to your email.", {
        position: "top-center",
        autoClose: 4000,
      });
    } else {
      toast.error("No OTP found. Please go back and request again.", {
        position: "top-center",
        autoClose: 3000,
      });
    }
  }, []);

  const handleChange = (e, index) => {
    const value = e.target.value;

    if (!/^[0-9]?$/.test(value)) return;

    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);

    if (value && index < 3) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

//  const handleSubmit = async (e) => {
//   e.preventDefault();
//   const enteredOtp = otp.join("");
//   const email = localStorage.getItem("instructor_email");

//   if (!email) {
//     toast.error("Email not found. Please go back and login again.");
//     return;
//   }

//   try {
//     const response = await fetch(SummaryApi.InstructorOtpVerification.url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         email: email,
//         otp: enteredOtp,
//       }),
//     });

//     const data = await response.json();

//     if (data.status === true) {
//       localStorage.removeItem("instructor_otp");
//       toast.success("OTP verified successfully!");
//     } else {
//       toast.error(data.message || "OTP verification failed.");
//     }
//   } catch (error) {
//     console.error("OTP verification error:", error);
//     toast.error("Something went wrong. Please try again.");
//   }
// };

// const handleSubmit = async (e) => {
//   e.preventDefault();
//   const enteredOtp = otp.join("");
//   const email = localStorage.getItem("instructor_email");

//   if (!email) {
//     toast.error("Email not found. Please go back and login again.");
//     return;
//   }

//   try {
//     const response = await fetch(SummaryApi.InstructorOtpVerification.url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         email: email,
//         otp: enteredOtp,
//       }),
//     });

//     const data = await response.json();

//     if (data.status === true) {
//       localStorage.removeItem("instructor_otp");
//       toast.success("OTP verified successfully!");

//       // Store instructor session info
//       sessionStorage.setItem("instructor_id", data.instructor_id);
//       sessionStorage.setItem("instructor_code", data.instructor_code || "");
//       sessionStorage.setItem("login_identifier", email);
//       sessionStorage.setItem("H7Z4L9VD2XK5JW8QRYT6", "active"); // session token

//       // Check instructor status and navigate accordingly
//       if (data.is_active === 1 && data.is_otp_verification === 1) {
//         // Active instructor - go to dashboard
//         setTimeout(() => {
//           navigate("/instructor-panel/dashboard", { replace: true });
//         }, 1000);
//       } else if (data.is_active === 0) {
//         // Inactive instructor - go to edit page to complete profile
//         const encodedInstructorId = btoa(data.instructor_id.toString());
//         setTimeout(() => {
//           navigate(
//             `/instructor-panel/edit-instructor?id=${encodeURIComponent(
//               encodedInstructorId
//             )}`,
//             { replace: true }
//           );
//         }, 1000);
//       } else {
//       // Inactive instructor - go to edit page to complete profile
//         const encodedInstructorId = btoa(data.instructor_id.toString());
//         setTimeout(() => {
//           navigate(
//             `/instructor-panel/edit-instructor?id=${encodeURIComponent(
//               encodedInstructorId
//             )}`,
//             { replace: true }
//           );
//         }, 1000);
//       }
//     } else {
//       toast.error(data.message || "OTP verification failed.");
//     }
//   } catch (error) {
//     console.error("OTP verification error:", error);
//     toast.error("Something went wrong. Please try again.");
//   }
// };

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true); // start loading

  const enteredOtp = otp.join("");
  const email = localStorage.getItem("instructor_email");

  if (!email) {
    toast.error("Email not found. Please go back and login again.");
    setLoading(false);
    return;
  }

  try {
    const response = await fetch(SummaryApi.InstructorOtpVerification.url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: email, otp: enteredOtp }),
    });

    const data = await response.json();

    if (data.status === true) {
      localStorage.removeItem("instructor_otp");
      toast.success("OTP verified successfully!");
      
      // Store session info
      sessionStorage.setItem("instructor_id", data.instructor_id);
      sessionStorage.setItem("instructor_code", data.instructor_code || "");
      sessionStorage.setItem("login_identifier", email);
      sessionStorage.setItem("H7Z4L9VD2XK5JW8QRYT6", "active");

      const encodedInstructorId = btoa(data.instructor_id.toString());
      setTimeout(() => {
        if (data.is_active === 1 && data.is_otp_verification === 1) {
          navigate("/instructor-panel/dashboard", { replace: true });
        } else {
          navigate(
            `/instructor-panel/edit-instructor?id=${encodeURIComponent(
              encodedInstructorId
            )}`,
            { replace: true }
          );
        }
        setLoading(false); // stop loading after navigation
      }, 1000);
    } else {
      toast.error(data.message || "OTP verification failed.");
      setLoading(false);
    }
  } catch (error) {
    console.error("OTP verification error:", error);
    toast.error("Something went wrong. Please try again.");
    setLoading(false);
  }
};

  return (
    <div className="min-h-screen w-full bg-white flex items-center justify-center">
                          <button
                onClick={() => window.history.back()}
                className="fixed top-10 left-4 z-50 flex items-center justify-center w-12 h-12 bg-white rounded-full shadow-lg hover:shadow-xl transition-all border border-gray-200 dark:bg-gray-800 dark:border-gray-700"
                aria-label="Go back"
              >
                <FaArrowLeft className="text-2xl text-[#103b6b] dark:text-white" />
              </button>
      <div className="w-full max-w-7xl min-h-[650px] flex rounded-3xl overflow-hidden shadow-lg">
        {/* Left Side - Background with logo */}
        <div className="w-1/2 relative">
          <img
            src={loginbg}
            alt="Instructor Background"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-30" />
          <div className="relative z-10 flex items-center justify-center h-full">
            <img src={logo} alt="Logo" className="w-64" />
          </div>
        </div>

        {/* Right Side - OTP Form */}
        <div className="w-1/2 bg-white flex items-start justify-center pt-12 px-10">
          <div className="w-full max-w-md">
            <h2 className="text-[36px] font-bold text-blue-900 mb-10 text-center font-inter">
              Enter OTP
            </h2>

            <form className="space-y-6" onSubmit={handleSubmit}>
              {/* OTP Inputs */}
              <div className="flex justify-between gap-4">
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    ref={(el) => (inputsRef.current[index] = el)}
                    className="w-14 h-16 text-center text-2xl border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 outline-none"
                  />
                ))}
              </div>

              {/* Submit Button */}
   <button
  type="submit"
  className="w-full py-3 bg-blue-900 hover:bg-blue-800 text-white font-semibold rounded-lg shadow-md transition duration-200 font-inter mt-6 flex justify-center items-center gap-2"
  disabled={loading} // disable button while loading
>
  {loading ? (
    <>
      <svg
        className="animate-spin h-5 w-5 text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v8H4z"
        ></path>
      </svg>
      Verifying...
    </>
  ) : (
    "VERIFY OTP"
  )}
</button>

            </form>
          </div>
        </div>
      </div>

      {/* Toast container */}
      <ToastContainer />
    </div>
  );
};

export default InstructorOtp;
